import type { GeminiAnalysisResponse } from '../types';

export const transformResume = async (resumeFile: File): Promise<GeminiAnalysisResponse> => {
  const workerUrl = import.meta.env.VITE_WORKER_URL;
  if (!workerUrl) throw new Error("VITE_WORKER_URL not set.");

  const formData = new FormData();
  formData.append('file', resumeFile);

  const MAX_RETRIES = 2;
  let attempt = 0;

  // 使用标签循环，确保逻辑清晰
  mainLoop: while (attempt <= MAX_RETRIES) {
    try {
      const response = await fetch(workerUrl, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        return await response.json() as GeminiAnalysisResponse;
      }

      // 优先拦截 429
      if (response.status === 429) {
        throw new Error("AI service quota exceeded. Please wait a minute before trying again.");
      }

      // 如果是 500 且可以重试
      if (response.status === 500 && attempt < MAX_RETRIES) {
        attempt++;
        await new Promise(res => setTimeout(res, 2000 * attempt));
        continue mainLoop;
      }

      // 其他错误
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Worker Error: ${response.status}`);

    } catch (e: any) {
      // 检查是否是由于栈溢出抛出的错误，如果是，直接向上抛出，不要重试
      if (e.name === 'RangeError') throw new Error("File too large or complex for current stack.");
      
      // 只有真正的网络异常才尝试最后一次重试
      if (attempt < MAX_RETRIES && (e.message?.includes('fetch') || e.name === 'TypeError')) {
        attempt++;
        await new Promise(res => setTimeout(res, 2000));
        continue mainLoop;
      }
      throw e;
    }
  }

  throw new Error("Maximum retries reached.");
};
